import React from 'react';
import { Trans, t } from '@lingui/macro';
import CardMain from '$/components/Interactions/cards/CardMain';
import { useCardContext } from '$/components/Interactions/cards/CardContext';
import { InteractionDisplayState } from '../InteractionInfo';
import PhoneNumber from '$/components/ui/Input/PhoneNumber';
import Textarea from '$/components/ui/Input/Basics/Textarea';
import { WebinarPlayerContext, WebinarPlayerUIState } from '$/components/WebinarPlayer/context';
import { withContextValue } from '$/hooks/withPartialContexts';
import Form from '$/components/ui/Form';
import Input from '$/components/ui/Input/Basics/Input';

type ContactRequestCardProps = {
  country?: string | null;
  buttonText?: string | null;
  attendeeName: string;
  displayState: InteractionDisplayState;
};

export const ContactRequestCard: React.FC = withContextValue<
  WebinarPlayerUIState,
  ContactRequestCardProps,
  ContactRequestCardProps
>(
  WebinarPlayerContext,
  ({ attendee }) => {
    const { displayState, attendeeName, interaction } = useCardContext();
    return {
      country: attendee?.country,
      displayState,
      attendeeName,
      buttonText: interaction.details?.buttonText,
    };
  },
  'ContactRequestCard'
)(({ country, displayState, attendeeName, buttonText }) => {
  switch (displayState) {
    case InteractionDisplayState.Result:
    case InteractionDisplayState.Submitted:
      return (
        <>
          <CardMain.SubmitBubble>
            <CardMain.IconThanks />
            <CardMain.Jumbotron>
              <Trans>
                Thanks, {attendeeName}!
                <p className='mt-1/4e' />
                Looking forward to connecting soon.
              </Trans>
            </CardMain.Jumbotron>
          </CardMain.SubmitBubble>
        </>
      );

    case InteractionDisplayState.Normal:
      return (
        <>
          <Form.Field
            name='details.name'
            className='w-full'
            component={<Input placeholder={t`Name`} />}
          />
          <Form.Field
            name='details.email'
            className='w-full'
            component={<Input placeholder={t`Email`} />}
          />
          <Form.Field
            name='details.phone'
            className='w-full'
            component={<PhoneNumber country={country} placeholder={t`Phone`} />}
          />
          <Form.Field
            name='details.message'
            component={<Textarea placeholder={`${t`Your message here`}...`} />}
          />
          <CardMain.SubmitButton>{buttonText || t`Submit`}</CardMain.SubmitButton>
          <Form.StopNonHubspotForm />
        </>
      );
  }
});
